
            import {expose} from 'comlink'
            import * as api from '/src/worker/pivotWorker.ts'

            expose(api)
          